module.exports = __webpack_public_path__ + "img/ausstellerpreis.6ccf5529.jpg";